import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Icon, Input, AutoComplete } from 'antd';
import { disableAutofill, formatAlphanumericWithSpaces } from '../helper';
import dataProvider from '../dataProvider';

const { Option, OptGroup } = AutoComplete;

const ConversationListHeader = ({
  isListLoading,
  findConversationByCustomerOrLead,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [results, setResults] = useState([]);

  const handleChange = useCallback((value) => {
    if (typeof value === 'string' && value?.length > 0) {
      setSearchValue(value);
      getTwilioResults(value);
    } else {
      handleClearResults();
    }
  });

  const handleSelect = (value) => {
    findConversationByCustomerOrLead(value);
    setSearchValue('');
  };

  const handleClearResults = () => {
    setResults([]);
    setSearchValue('');
  };

  const convertPhoneFormat = (phone) => {
    const cleanedPhone = `${phone}`.replace(/\D/g, '');
    const match = cleanedPhone.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const number = `(${match[2]}) ${match[3]}-${match[4]}`;
      return number;
    }
    return phone;
  };

  const getTwilioResults = useCallback((value) => {
    if (value?.length > 0) {
      dataProvider
        .getList('customer-search-detail', {
          filter: {
            q: formatAlphanumericWithSpaces(value),
          },
          sort: { field: 'first_name', order: 'ASC' },
          pagination: { page: 1, perPage: 10 },
        })
        .then((res) => {
          setResults(res.data);
        });
    } else {
      setResults([]);
    }
  });

  const mapResults = useCallback(() => {
    if (results?.length > 0) {
      return results.map((item, index) => {
        const isLast = index === results.length - 1;
        return (
          <Option
            key={item.id}
            value={`${item?.id}`}
            style={{ borderBottom: !isLast && '1px solid #d9d9d9' }}
          >
            {`${item.first_name} ${item.last_name}`} <br />
            {convertPhoneFormat(item.phone)}
          </Option>
        );
      });
    }
    return [];
  });

  const options = useMemo(() => {
    return [
      <OptGroup key="result" label="Results">
        {mapResults()}
      </OptGroup>,
    ];
  }, [mapResults]);

  useEffect(() => {

    const customerId = localStorage.getItem('chat_customer_id');
    if((customerId !== "undefined") && (customerId !== null)) {
      findConversationByCustomerOrLead(customerId);
      getTwilioResults(customerId);
    }
  }, []);

  return (
    <>
      <AutoComplete
        value={searchValue}
        name="address_line_1"
        className="conversation-search"
        dataSource={options}
        optionLabelProp="label"
        style={{ width: '100%' }}
        onChange={handleChange}
        onSelect={handleSelect}
      >
        <Input
          autoComplete={disableAutofill}
          prefix={<Icon type="search" />}
          suffix={
            isListLoading ? (
              <Icon type="loading" onClick={handleClearResults} />
            ) : (
              results?.length > 0 && (
                <Icon type="close" onClick={handleClearResults} />
              )
            )
          }
          placeholder="Search or Start Conversation"
        />
      </AutoComplete>
    </>
  );
};

export default ConversationListHeader;
